import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { gethauller } from '../redux/hauller';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function Progress() {
  return <div>Loading...</div>;
}

export default function BasicModal() {
  const dt = new Date();
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [gender, setGender] = React.useState("none");
  const [ownershiptype, setOwnershipType] = React.useState("none");
  const [haulliagetype, setHaulliageType] = React.useState("none");
  const [vehiclesetter, setVehicleSetter] = React.useState([]);
  const [personName, setPersonName] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const admin = useSelector((state) => state.admin);
  const farmer = useSelector((state) => state.farmer);
  const product = useSelector((state) => state.product);
  const staff = useSelector((state) => state.staff);
  const sales = useSelector((state) => state.sales);
  const agent = useSelector((state) => state.hauler);
  const warehouse = useSelector((state) => state.warehouse);
  const service = useSelector((state) => state.service);
  const center = useSelector((state) => state.center);
  const commodity = useSelector((state) => state.commodity);

  const Food = [
    { value: "Cereals" },
    { value: "Industrial crops" },
    { value: "Legumes" },
    { value: "Fruits" },
    { value: "Vegetables" },
    { value: "Starchy" },
    { value: "tuber" },
    { value: "root crops" }
  ];

  const names = [
    "Comprehensive",
    "Third party",
    "Goods in transit",
  ];

  const vehiclesChange = () => {
    const insurance = personName;
    const expirydate = document.getElementById("expiry").value;
    const registration = document.getElementById("registration").value;
    const drivername = document.getElementById("drivername").value;
    const licensenum = document.getElementById("licensenum").value;
    const contact = document.getElementById("drivercontact").value;
    const list = {
      insurance,
      expirydate,
      registration,
      drivername,
      contact,
      licensenum
    };
    setVehicleSetter([...vehiclesetter, list]);
    setPersonName([]);
    document.getElementById("expiry").value = "";
    document.getElementById("drivername").value = "";
    document.getElementById("registration").value = "";
    document.getElementById("licensenum").value = "";
    document.getElementById("drivercontact").value = "";
  };

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const clearForm = () => {
    document.getElementById("haullier").value = "";
    document.getElementById("contact").value = "";
    document.getElementById("years").value = "";
    document.getElementById("address").value = "";
    document.getElementById("principalID").value = "";
    document.getElementById("email").value = "";
    document.getElementById("capacity").value = "";
    setGender("none");
    setOwnershipType("none");
    setHaulliageType("none");
    setVehicleSetter([]);
    setPersonName([]);
  };

  const addFarmer = () => {
    setLoading(true);
    const doer = async () => {
      try {
        const response = await axios.post("https://embert.sisrevolution.com/api/haullier/addhaullier/", {
          haullier: document.getElementById("haullier").value,
          contact: document.getElementById("contact").value,
          years: document.getElementById("years").value,
          gender,
          address: document.getElementById("address").value,
          vehicleslist: vehiclesetter,
          principalID: document.getElementById("principalID").value,
          email: document.getElementById("email").value,
          capacity: document.getElementById("capacity").value,
          haulliagetype,
          ownershiptype,
        });

        if (response.status === 200) {
          setSnackbarMessage('Haullier added successfully!');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          dispatch(gethauller({ data: response.data }));
          clearForm();
          handleClose();
        }
        setLoading(false);
      } catch (err) {
        console.error(err);
        setSnackbarMessage('Failed to add Haullier. Please try again.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      }
    };
    doer();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Add Haullier / Agent
      </Button>

      <Dialog fullWidth minWidth="sm" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title">
          Add new Haullier / Agent
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField id="haullier" label="Haullier's Name" type="text" autoComplete="current-text" />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Gender"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              slotProps={{ select: { native: true } }}
            >
              <option value="none">Choose</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Co-operate">Co-operate</option>
            </TextField>
            <TextField
              id="years"
              label="Years in business"
              type="text"
              autoComplete="current-text"
              InputProps={{ endAdornment: <InputAdornment position="end">years</InputAdornment> }}
            />
            <TextField id="contact" label="Contact" type="tel" autoComplete="current-text" />
            <TextField id="address" label="Address" type="text" autoComplete="current-text" />
            
            <div style={{ border: "solid", borderRadius: "5px", borderColor: "gray", borderWidth: "1px", margin: "7px" }}>
              <p style={{ textAlign: "center" }}><b>Add Vehicle</b></p>
              <FormControl sx={{ m: 1, width: 225 }}>
                <InputLabel id="demo-multiple-checkbox-label">Insurance Terms</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={personName}
                  onChange={handleChange}
                  input={<OutlinedInput label="Insurance Terms" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                >
                  {names.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={personName.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                id="expiry"
                label="Insurance Expiry"
                type="date"
                autoComplete="current-text"
                InputProps={{ startAdornment: <InputAdornment position="start"></InputAdornment> }}
              />
              <TextField id="registration" label="Vehicle Registration" type="text" autoComplete="current-text" />
              <TextField id="drivername" label="Driver's Name" type="text" autoComplete="current-text" />
              <TextField id="drivercontact" label="Driver's Contact" type="tel" autoComplete="current-text" />
              <TextField id="licensenum" label="Driver's License Number" type="text" autoComplete="current-text" />
              <br />
              <div style={{ textAlign: "center", marginBottom: "5px" }}>
                <Button onClick={vehiclesChange} variant='outlined'>Add Vehicle to Haullier</Button>
              </div>
            </div>

            {vehiclesetter.map((i, index) => (
              <div key={index} style={{ border: "solid", borderRadius: "5px", borderColor: "gray", borderWidth: "1px", margin: "7px" }}>
                <p style={{ textAlign: "center" }}>Vehicle {index + 1}</p>
                <p>Insurance Type: {i.insurance.join(', ')}</p>
                <p>Insurance Expiry: {i.expirydate}</p>
                <p>Vehicle Registration: {i.registration}</p>
                <p>Driver's Name: {i.drivername}</p>
                <p>License Number: {i.licensenum}</p>
              </div>
            ))}

            <TextField
              id="outlined-select-currency-native"
              select
              label="Haulliage Type"
              value={haulliagetype}
              onChange={(e) => setHaulliageType(e.target.value)}
              slotProps={{ select: { native: true } }}
            >
              <option value="none">Choose</option>
              <option value="Primary">Primary</option>
              <option value="Secondary">Secondary</option>
            </TextField>
            <TextField id="principalID" label="Principal Agent ID" type="text" autoComplete="current-text" />
            <TextField id="email" label="Email" type="email" autoComplete="current-text" />
            <TextField
              id="capacity"
              label="Haullage Capacity"
              type="text"
              autoComplete="current-text"
              InputProps={{ endAdornment: <InputAdornment position="end">tons</InputAdornment> }}
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Ownership Types"
              value={ownershiptype}
              onChange={(e) => setOwnershipType(e.target.value)}
              slotProps={{ select: { native: true } }}
            >
              <option value="none">Choose</option>
              <option value="Owned">Owned</option>
              <option value="Leased">Leased</option>
              <option value="Co-operative">Co-operative</option>
            </TextField>
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<EngineeringIcon />} size="large" onClick={addFarmer}>
                Submit New Haullier / Agent
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}